// extracted by mini-css-extract-plugin
export default {"list":"Tags_list__ISXD4","addTag":"Tags_addTag__XiuN3","input":"Tags_input__z81pu","listTags":"Tags_listTags__CpaT9"};